module.exports = __webpack_public_path__ + "h5/img/huodong_1.8b2768a1.jpg";